import styled from "@emotion/styled";
import {
  Container as FindOutMoreContainer,
  Message as FindOutMoreMessage,
} from "scmp-sdk/components/newsletter/newsletter-widget/find-out-more/styles";
import { StyledIconArrowPrevious } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/email-form/styles";
import { SubmitButton as SignUpButton } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/sign-up-button/styles";
import {
  AgreementDescription as SignUpNewsletterAgreementDescription,
  Container as SignUpNewsletterContainer,
  Summary as SignUpNewsletterSummary,
  Title as SignUpNewsletterTitle,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/styles";
import {
  Container as SignUpSuccessMessageContainer,
  Title as SignUpSuccessMessageTitle,
  StyledFollowUsOnFacebook,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-success-message/styles";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import { theme as mediaTheme } from "shared/lib/styles";

export const theme: ThemeType = {
  findOutMore: {
    titleFontStyle: "small",
  },
  hasSummaryLine: false,
  newsletterIcon: {
    icon: "white",
  },
  orientation: "portrait",
  root: {
    containerSize: "medium",
  },
  signUpNewsletter: {
    checkboxStyle: "black",
    summaryFontStyle: "small",
    titleFontStyle: "small",
  },
  signUpSuccess: {
    checkEmailMessageStyle: "gray",
    hasCheckEmail: true,
    hasSeeMoreLinks: true,
    titleFontStyle: "medium",
  },
};

export const Container = styled.div`
  ${StyledIconArrowPrevious} {
    path {
      stroke: #ffffff;
    }
  }

  ${FindOutMoreMessage} {
    color: #ffffff;
  }

  ${SignUpButton} {
    background-color: #000000;
  }

  ${SignUpNewsletterContainer} {
    ${SignUpNewsletterAgreementDescription} {
      color: #a1a1a1;
    }

    ${SignUpNewsletterTitle}, ${SignUpNewsletterSummary} {
      color: #ffffff;
    }
  }

  ${SignUpSuccessMessageContainer} {
    grid-template-areas:
      "Icon Title"
      ". Footer";
    grid-template-columns: min-content 1fr;

    color: #ffffff;
    text-align: start;

    ${StyledFollowUsOnFacebook} {
      margin-block-start: 0;
    }

    ${SignUpSuccessMessageTitle} {
      text-align: start;
    }
  }

  ${mediaTheme.breakpoints.up("tablet")} {
    ${FindOutMoreContainer}, ${SignUpNewsletterContainer} {
      justify-items: flex-start;

      text-align: start;
    }
  }
`;
